// control de productos y reseñas, carrito, cupones y resumen de compra
import { types } from '../types/types';

import { CHECKOUT_ORDER } from '../constants/shop/order_const';
import { CART_COUPON } from '../constants/shop/coupon/coupon_const';
import { PRODUCT_ACTIVE_REVIEW } from '../constants/shop/product_const';
import { CART_SUMMARY, SHIPPING_METHOD } from '../constants/shop/shop_constants';
import { LOGIN_CART_RECEIVED, LOGIN_CART_REVIEWED } from '../helpers/shop/loginCart';

// información de tienda
const initialState = {
    fetched: false, // se realizó la petición a backend
    states: [], // estados donde existen sucursales
    branches: [], // sucursales
    products: [], // productos de tienda
    rvProducts: [], // productos vistos recientemente
    featuredProducts: [], // productos destacados
    promotionProducts: [], // productos con promoción
    promotions: [], // promociones
    categories: [], // categorías de productos
    brands: [], // marcas de productos
    banners: { // banners
        desktop: [],
        mobile: [],
        tablet: []
    },
    shipping: {
        methods: { // métodos de envío ONL
            full_list: [], // todos
            client_list: [], // se excluye envío gratis si no cumple condiciones
            selected: SHIPPING_METHOD, // elegido
            radio_button: null
        },
        action: '', // actualizar/eliminar (admin)
    },
    cart: { // carrito de cliente
        refrig_shipment: false, // envío necesita refrigeración
        item: [], // productos en carrito
        summary: CART_SUMMARY, // resumen de carrito
        item_summary: [], // Tu orden (productos, precio individual y total)
        cart_promotion: [], // promociones activas (en base a productos de carrito)
        coupon: CART_COUPON, // cupón aplicado
        checkout: { // agilizar checkout
            skip: false, // ¿pedido activo?
            fill: false, // rellenar datos de pedido
            order: CHECKOUT_ORDER
        }
    },
    coupons: [], // cupones disponibles
    activeReview: PRODUCT_ACTIVE_REVIEW
};

const normalizeLoginCheckout = checkout => {
    const incoming = checkout || {};
    const order = incoming.order || {};
    return {
        ...initialState.cart.checkout,
        ...incoming,
        order: {
            ...CHECKOUT_ORDER,
            ...order,
            shipping: {
                ...CHECKOUT_ORDER.shipping,
                ...(order.shipping || {})
            }
        }
    };
};

export const shopReducer = (state = initialState, action) => {
    switch (action.type) {
        case LOGIN_CART_RECEIVED: {
            const { login_shipping, merge_review, checkout, ...cart } = action.payload;
            const selected = login_shipping || SHIPPING_METHOD;
            return {
                ...state,
                login_cart_review: merge_review ? { ...merge_review, pending: true,
                    pending_coupon: cart.pending_coupon || '' } : null,
                cart: { ...initialState.cart, ...cart, coupon: cart.coupon || CART_COUPON,
                    summary: { ...CART_SUMMARY, ...cart.summary },
                    checkout: normalizeLoginCheckout(checkout) },
                shipping: { ...state.shipping, methods: { ...state.shipping.methods,
                    selected, radio_button: selected._id || null } }
            };
        }
        case LOGIN_CART_REVIEWED:
            return { ...state, login_cart_review: state.login_cart_review
                ? { ...state.login_cart_review, pending: false } : null };
        case types.shippingMethodsLoaded:
            return {
                ...state,
                shipping: {
                    ...state.shipping,
                    methods: {
                        ...state.shipping.methods,
                        full_list: action.payload,
                        client_list: action.payload.filter(e => e.cost !== 0)
                    }
                }
            };
        case types.shippingMethodSelected: {
            const { selected: { cost } } = action.payload;
            return {
                ...state,
                shipping: {
                    ...state.shipping,
                    methods: {
                        ...state.shipping.methods,
                        ...action.payload
                    }
                },
                cart: {
                    ...state.cart,
                    summary: {
                        ...state.cart.summary,
                        total: // sumar costo de envío a total de carrito
                            Math.round((state.cart.summary.subtotal + cost) * 1e2) / 1e2
                    }
                }
            };
        }
        case types.shippingMethodSaved:
            return {
                ...state,
                shipping: {
                    ...state.shipping,
                    methods: {
                        ...state.shipping.methods,
                        full_list: [
                            ...state.shipping.methods.full_list,
                            action.payload
                        ]
                    }
                }
            };
        case types.shippingMethodsDeleted:
            return {
                ...state,
                shipping: {
                    ...state.shipping,
                    methods: {
                        ...state.shipping.methods,
                        full_list: state.shipping.methods.full_list.filter(e => !action.payload.includes(e._id))
                    }
                }
            };
        case types.shopProductsLoaded:
            return {
                ...state,
                ...action.payload
            };
        case types.shopInfoLoaded: {
            const {
                categories, brands, banners, states, branches, shipping
            } = action.payload;
            
            return {
                ...state,
                categories, brands, banners,
                states, branches,
                shipping: {
                    ...state.shipping,
                    methods: {
                        ...state.shipping.methods,
                        full_list: shipping,
                        client_list: shipping.filter(e => e.cost !== 0)
                    }
                },
                fetched: true
            };
        }
        case types.shopCouponsLoaded:
            return {
                ...state,
                coupons: action.payload
            };
        case types.checkoutFillData: // fast checkout
            return {
                ...state,
                cart: {
                    ...state.cart,
                    checkout: {
                        ...state.cart.checkout,
                        fill: action.payload
                    }
                }
            };
        case types.checkoutOrderData: // fast checkout
            return {
                ...state,
                cart: {
                    ...state.cart,
                    checkout: {
                        ...state.cart.checkout,
                        skip: true,
                        order: {
                            ...state.cart.checkout.order,
                            ...action.payload
                        }
                    }
                }
            };
        case types.checkoutPaymentData: // fast checkout
            return {
                ...state,
                cart: {
                    ...state.cart,
                    checkout: {
                        ...state.cart.checkout,
                        order: {
                            ...state.cart.checkout.order,
                            payment: {
                                ...state.cart.checkout.order.payment,
                                ...action.payload
                            }
                        }
                    }
                }
            };
        case types.checkoutPaymentResolved:
            return {
                ...state,
                cart: {
                    ...state.cart,
                    checkout: {
                        skip: false,
                        fill: false,
                        order: CHECKOUT_ORDER
                    }
                }
            };
        case types.shoppingCart: {
            const { summary, checkout, ...data } = action.payload;
            const { shipping: { methods: { selected: { cost } } } } = state;

            let order = {};
            let lite_data = {}
            if (checkout) {
                const { order: o, ...l } = checkout;
                order = o;
                lite_data = l;
            }

            return {
                ...state,
                cart: {
                    ...state.cart,
                    ...data,
                    coupon: data.coupon || CART_COUPON,
                    requires_cart_review: Boolean(data.btl_confirmation || data.coupon_email_required),
                    summary: {
                        ...state.cart.summary, ...summary,
                        total: Math.round((summary.subtotal + cost) * 1e2) / 1e2
                    },
                    checkout: {
                        ...state.cart.checkout,
                        ...lite_data,
                        order: {
                            ...state.cart.checkout.order,
                            ...order
                        }
                    }
                }
            };
        }
        case types.shopUpdateQuantity:
            return {
                ...state,
                cart: {
                    ...state.cart,
                    item: state.cart.item.map(
                        e => (e.prod_var_id === action.payload.prod_var_id) ?
                            { ...e, quantity: action.payload.quantity }
                        : e
                    )
                }
            };
        case types.shopEmptyCart:
            return {
                ...state,
                login_cart_review: null,
                cart: {
                    ...state.cart,
                    refrig_shipment: false,
                    item: [],
                    summary: CART_SUMMARY,
                    item_summary: [],
                    cart_promotion: [],
                    coupon: CART_COUPON
                }
            };
        case types.shopCoupon:
            return {
                ...state,
                coupon: action.payload
            }
        case types.shopProductViewed: {
            return {
                ...state,
                rvProducts: [
                    action.payload,
                    ...state.rvProducts.filter(e => e.prod_id !== action.payload.prod_id).slice(0, Math.min(10, state.rvProducts.length))
                ]
            };
        }
        case types.reviewAdded:
            return {
                ...state,
                products: state.products.map(
                    e => (e._id === action.payload.prod_id) ?
                    { ...e, reviews: [...e.reviews, action.payload] }
                    : e
                ),
                activeReview: PRODUCT_ACTIVE_REVIEW
            };
        case types.reviewSelected:
            return {
                ...state,
                activeReview: action.payload,
            };
        case types.reviewUpdated:
            return {
                ...state,
                products: state.products.map(
                    e => (e._id === action.payload.prod_id) ?
                    { ...e, reviews: e.reviews.map(
                            r => (r._id === action.payload._id) ? action.payload : r
                        )
                    }
                    : e
                ),
                activeReview: PRODUCT_ACTIVE_REVIEW
            };
        case types.reviewDeleted:
            return {
                ...state,
                products: state.products.map(
                    e => (e._id === action.payload.prod_id) ?
                    { ...e, reviews: e.reviews.filter(
                            r => (r._id !== action.payload._id)
                        )
                    }
                    : e
                )
            };
        case types.reviewSummaryUpdated: {
            const { productId, summary } = action.payload;
            const updateProduct = product => (
                String(product._id || product.prod_id) === String(productId)
            ) ? {
                ...product,
                review_summary: summary
            } : product;

            return {
                ...state,
                products: state.products.map(updateProduct),
                rvProducts: state.rvProducts.map(updateProduct),
                featuredProducts: state.featuredProducts.map(updateProduct),
                promotionProducts: state.promotionProducts.map(updateProduct)
            };
        }
        default:
            return state;
    }
};
